import { RowActionProps } from "../../../components/LassoGrid";
import { useUpdateUserMutation } from "../../../api/userApiSlice";
import { MenuItem } from "@mui/material";

const InactiveActions = (props: RowActionProps) => {
    const [ updateUser ] = useUpdateUserMutation();

    const reactivateUser = (event: any) => {
        const activeUntil = new Date();
        activeUntil.setMonth(activeUntil.getMonth() + 24);
        const updatedFields = {
            Active: true,
            ActiveUntil: activeUntil.toISOString().split('T')[0]
        }
        updateUser({
            userID: props.rowData.ID,
            fields: updatedFields
        });
        props.close(event);
    }

    return (
        <MenuItem onClick={reactivateUser}>Reactivate</MenuItem>
    )
}

export default InactiveActions